/* eslint-disable no-unused-vars */
import { Palette } from 'config';
import styled from 'styled-components';

export const InputBox = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  border-width: 1px;
  border-radius: 4px;
  border-style: solid;
  border-color: #e2e8f0;
  overflow: hidden;
  width: 100px;
`;

export const BidContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  margin-left: -8px;

  input {
    min-width: 52px;
    max-width: 300px;
    field-sizing: content;
    width: auto !important;
  }
`;

export const InputUnits = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 10px;
  gap: 10px;
  width: 28px;
  height: 40px;
  flex: none;
  order: 0;
  flex-grow: 0;
`;
export const InputValue = styled.input`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 8px;
  gap: 8px;
  width: 70px;
  height: 40px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  box-shadow: inset 0px 2px 4px rgba(0, 0, 0, 0.04);
  flex: none;
  order: 1;
  flex-grow: 0;
`;

export const Container = styled.div`
  .MuiAccordion-root {
    box-shadow: none;
    margin-bottom: 0;
  }
  .MuiAccordionDetails-root {
    padding: 0;
  }
  .MuiTypography-subtitle1 {
    text-wrap: nowrap;
  }
`;

export const Text = styled.span`
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  color: ${Palette.PrimaryGray._700};
`;

export const RadioBoxGroup = styled.div`
  display: inline-flex;
  margin-bottom: 8px;
  border-radius: 4px;
  outline: ${({ showborder }) => showborder === 'true' && `1px solid ${Palette.Red._300}`};
  pointer-events: ${({ disabled }) => disabled && `none !important`};
`;
